export default "__VITE_ASSET__CZbqrY42__"